/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetUserNextBestActions200, HTTPValidationError } from './platformapi.schemas';

import getUserNextBestActionsMutator from '../custom-axios-instance';
import dismissOnboardVideoMutator from '../custom-axios-instance';
import handleWebhookEventMutator from '../custom-axios-instance';

/**
 * Returns list of next best actions for current user
 * @summary Get User Next Best Actions
 */
export const getUserNextBestActions = (signal?: AbortSignal) => {
  return getUserNextBestActionsMutator<GetUserNextBestActions200>({
    url: `${import.meta.env['VITE_API_HOST']}/next_best_actions`,
    method: 'GET',
    signal,
  });
};

export const getGetUserNextBestActionsQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/next_best_actions`] as const;
};

export const getGetUserNextBestActionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserNextBestActions>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserNextBestActions>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserNextBestActionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserNextBestActions>>> = ({ signal }) =>
    getUserNextBestActions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserNextBestActions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserNextBestActionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserNextBestActions>>
>;
export type GetUserNextBestActionsQueryError = void | HTTPValidationError;

export function useGetUserNextBestActions<
  TData = Awaited<ReturnType<typeof getUserNextBestActions>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserNextBestActions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserNextBestActions>>,
          TError,
          Awaited<ReturnType<typeof getUserNextBestActions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserNextBestActions<
  TData = Awaited<ReturnType<typeof getUserNextBestActions>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserNextBestActions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserNextBestActions>>,
          TError,
          Awaited<ReturnType<typeof getUserNextBestActions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserNextBestActions<
  TData = Awaited<ReturnType<typeof getUserNextBestActions>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserNextBestActions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get User Next Best Actions
 */

export function useGetUserNextBestActions<
  TData = Awaited<ReturnType<typeof getUserNextBestActions>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserNextBestActions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserNextBestActionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Dismisses onboarding video for current user
 * @summary Dismiss Onboard Video
 */
export const dismissOnboardVideo = (signal?: AbortSignal) => {
  return dismissOnboardVideoMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/next_best_actions/dismiss`,
    method: 'POST',
    signal,
  });
};

export const getDismissOnboardVideoMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissOnboardVideo>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof dismissOnboardVideo>>, TError, void, TContext> => {
  const mutationKey = ['dismissOnboardVideo'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissOnboardVideo>>,
    void
  > = () => {
    return dismissOnboardVideo();
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissOnboardVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissOnboardVideo>>
>;

export type DismissOnboardVideoMutationError = void | HTTPValidationError;

/**
 * @summary Dismiss Onboard Video
 */
export const useDismissOnboardVideo = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof dismissOnboardVideo>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof dismissOnboardVideo>>, TError, void, TContext> => {
  const mutationOptions = getDismissOnboardVideoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Handles webhook events from third party services related to Next Best Action
 * @summary Handle Webhook Event
 */
export const handleWebhookEvent = (signal?: AbortSignal) => {
  return handleWebhookEventMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/next_best_actions/webhook`,
    method: 'POST',
    signal,
  });
};

export const getHandleWebhookEventMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof handleWebhookEvent>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof handleWebhookEvent>>, TError, void, TContext> => {
  const mutationKey = ['handleWebhookEvent'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof handleWebhookEvent>>, void> = () => {
    return handleWebhookEvent();
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleWebhookEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleWebhookEvent>>
>;

export type HandleWebhookEventMutationError = void;

/**
 * @summary Handle Webhook Event
 */
export const useHandleWebhookEvent = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof handleWebhookEvent>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof handleWebhookEvent>>, TError, void, TContext> => {
  const mutationOptions = getHandleWebhookEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
